/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Error_Occur_TitleInputs */

const en_dialog_error_occur_title = /** @type {(inputs: Dialog_Error_Occur_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An Error Occurred`)
};

const ar_dialog_error_occur_title = /** @type {(inputs: Dialog_Error_Occur_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حدث خطأ`)
};

const de_dialog_error_occur_title = /** @type {(inputs: Dialog_Error_Occur_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Fehler ist aufgetreten`)
};

const es_dialog_error_occur_title = /** @type {(inputs: Dialog_Error_Occur_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se ha producido un error`)
};

const fr_dialog_error_occur_title = /** @type {(inputs: Dialog_Error_Occur_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une erreur est survenue`)
};

const it_dialog_error_occur_title = /** @type {(inputs: Dialog_Error_Occur_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si è verificato un errore`)
};

const ja_dialog_error_occur_title = /** @type {(inputs: Dialog_Error_Occur_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エラーが発生しました`)
};

const ko_dialog_error_occur_title = /** @type {(inputs: Dialog_Error_Occur_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`오류 발생`)
};

const pt_br_dialog_error_occur_title = /** @type {(inputs: Dialog_Error_Occur_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocorreu um erro`)
};

const ru_dialog_error_occur_title = /** @type {(inputs: Dialog_Error_Occur_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Произошла ошибка`)
};

const th_dialog_error_occur_title = /** @type {(inputs: Dialog_Error_Occur_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกิดข้อผิดพลาด`)
};

const tr_dialog_error_occur_title = /** @type {(inputs: Dialog_Error_Occur_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir Hata Oluştu`)
};

const zh_cn_dialog_error_occur_title = /** @type {(inputs: Dialog_Error_Occur_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发生错误`)
};

const zh_tw_dialog_error_occur_title = /** @type {(inputs: Dialog_Error_Occur_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`發生錯誤`)
};

/**
* | output |
* | --- |
* | "An Error Occurred" |
*
* @param {Dialog_Error_Occur_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_error_occur_title = /** @type {((inputs?: Dialog_Error_Occur_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Error_Occur_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_error_occur_title(inputs)
	if (locale === "ar") return ar_dialog_error_occur_title(inputs)
	if (locale === "de") return de_dialog_error_occur_title(inputs)
	if (locale === "es") return es_dialog_error_occur_title(inputs)
	if (locale === "fr") return fr_dialog_error_occur_title(inputs)
	if (locale === "it") return it_dialog_error_occur_title(inputs)
	if (locale === "ja") return ja_dialog_error_occur_title(inputs)
	if (locale === "ko") return ko_dialog_error_occur_title(inputs)
	if (locale === "pt_br") return pt_br_dialog_error_occur_title(inputs)
	if (locale === "ru") return ru_dialog_error_occur_title(inputs)
	if (locale === "th") return th_dialog_error_occur_title(inputs)
	if (locale === "tr") return tr_dialog_error_occur_title(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_error_occur_title(inputs)
	return zh_tw_dialog_error_occur_title(inputs)
});